import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M13 9.667V8.482c0-1.544-1.674-2.505-3.008-1.728l-6.03 3.518c-1.324.772-1.324 2.684 0 3.455l6.03 3.518c1.333.778 3.008-.184 3.008-1.727v-1.185l4.992 2.912c1.334.778 3.008-.184 3.008-1.727V8.482c0-1.544-1.674-2.505-3.008-1.728z"
    }
  )
);
var SvgRewindFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var RewindFilled_default = SvgRewindFilled;

export { RewindFilled_default as default };
